import { useState, useEffect } from "react";

const STORAGE_KEY = "lifetime_panic_timer_start";
const DURATION_MS = 2 * 60 * 60 * 1000; // 2 hours

interface TimeLeft {
  hours: string;
  minutes: string;
  seconds: string;
}

const pad = (n: number) => String(n).padStart(2, "0");

const getOrResetStart = (): number => {
  const stored = localStorage.getItem(STORAGE_KEY);
  const now = Date.now();
  if (stored) {
    const start = parseInt(stored, 10);
    if (now - start < DURATION_MS) return start;
  }
  localStorage.setItem(STORAGE_KEY, String(now));
  return now;
};

const useCountdownTimer = (): TimeLeft => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ hours: "02", minutes: "00", seconds: "00" });

  useEffect(() => {
    let start = getOrResetStart();

    const tick = () => {
      const elapsed = Date.now() - start;
      let remaining = DURATION_MS - elapsed;

      if (remaining <= 0) {
        // Reset for this user
        const now = Date.now();
        localStorage.setItem(STORAGE_KEY, String(now));
        start = now;
        remaining = DURATION_MS;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      setTimeLeft({ hours: pad(h), minutes: pad(m), seconds: pad(s) });
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return timeLeft;
};

export default useCountdownTimer;
